import axios from 'axios';

import routes from 'app/routes';

export default {
  close: (templateId, programIds, onSuccess) => {
    axios
      .patch(routes.api.templates.close_all(templateId), { program_ids: programIds })
      .then((response) => {
        onSuccess(response.data.data);
      });
  },
};
